function n(){return navigator.appVersion.includes("Win")}export{n as a};
